export enum MythActionType {
    TYPE_CLASSIC = 0, TYPE_GOLDEN = 1,TYPE_WHITE
}

export enum UserActionStatus {
//活动未开始
    ACTION_UNSTARTED = "ACTION_UNSTARTED",
//白名单模式不在白名单
    WHITE_MODE_NO_ELIGIBLE = "WHITE_MODE_eligible",
//白名单模式在白名单，未领取
    WHITE_MODE_CLAIMABLE = "WHITE_MODE_claimable",
//白名单模式在白名单，已领取
    WHITE_MODE_CLAIMED = "WHITE_MODE_claimed",
//PASS模式活动在申请打新阶段时，用户未申请打新
    PASS_MODE_APPLYABLE = "PASS_MODE_applyable",
//PASS模式活动在申请打新阶段时，用户已申请打新
    PASS_MODE_APPLYED = "PASS_MODE_applyed",
//PASS模式活动在等待打新中签结果阶段，用户未申请打新
    PASS_MODE_LOTTERY_NOT_APPLIED = "PASS_MODE_lottery_not_applied",
//PASS模式活动在等待打新中签结果阶段，用户已申请打新
    PASS_MODE_LOTTERY_APPLIED = "PASS_MODE_lottery_applied",
//PASS模式活动打新结果已出，中签未领取
    PASS_MODE_APPLY_SUCCESS_UNMINT = "PASS_MODE_apply_success_unmint",
//PASS模式活动打新结果已出，中签领取
    PASS_MODE_APPLY_SUCCESS_MINTED = "PASS_MODE_apply_success_minted",
//PASS模式活动打新结果已出，未中签
    PASS_MODE_APPLY_FAILED = "PASS_MODE_apply_failed",
//PASS模式活动打新结果已出，用户未申请打新
    PASS_MODE_APPLY_FAILED_NOT_APPLY = "PASS_MODE_apply_failed_unapply",
//活动领取已过期
    ACTION_EXPIRED = "ACTION_EXPIRED",
}
//活动当前阶段0=未开始，1=申请打新中，2=打新结束等待开奖中，3=开奖结束,等待领取，4=活动已过期
export enum ActionStatus {
    ACTION_STATUS_UNSTARTED,
    ACTION_STATUS_APPLYING,
    ACTION_STATUS_LOTTERING,
    ACTION_STATUS_CLAIMING,
    ACTION_STATUS_EXPIRED
}




